import { FileUpload } from '@/components/FileUpload';

interface ReceiptAttachFieldProps {
  file: File | null;
  onChange: (file: File | null) => void;
  label?: string;
}

export function ReceiptAttachField({ file, onChange, label }: ReceiptAttachFieldProps) {
  return (
    <FileUpload
      label={label ?? 'Receipt (optional)'}
      accept={{ 'image/*': [], 'application/pdf': [] }}
      maxFiles={1}
      files={file ? [file] : []}
      onFilesSelected={(files) => onChange(files[0] ?? null)}
      onRemove={() => onChange(null)}
    />
  );
}
